<template>
  <div class="group_index">
    <div class="group_top"></div>
    <div class="group_list">
      <el-row :gutter="10" v-show="true">
        <el-col :span="6" v-for="item in list" :key="item.group_id  ">
          <router-link :to="'/viewGroup?id=' + item.group_id" tag="div" class="group_item">
            <!-- <transition name="slide-fade"> -->
            <div class="group_item_img" >
              <img :src=" serve + item.images" alt />
            </div>
            <!-- </transition> -->
            <div class="group_item_position">
              <div class="group_item_title">{{item.title}}</div>
              <div class="group_item_money">
                <span class="group_item_money1">&yen;{{item.selling_price}}</span>
                <span class="group_item_money2">&yen;{{item.g_price}}</span>
                <span>
                  <el-button size="mini" type="primary" @click="change_group(item.group_id)">立即拼团</el-button>
                </span>
              </div>
            </div>
          </router-link>
        </el-col>
      </el-row>
    </div>

    <div
      class="group_list"
      v-if="list.length == 0"
      style="text-align:center;height:500px;font-size:30px"
    >暂无商品</div>
    <div class="unfol" v-if="list.length>=8" @click="change_unfol">
      {{unfol ? '展开' : '收起'}}
      <i
        class="iconfont"
        :class=" unfol == true ? 'icon-down-hollow': 'icon-xiala2'"
      ></i>
    </div>

    <div class="group_box_box">
      <div class="group_box">
        <div class="pack">拼大包装</div>
        <div class="classify">
          <div
            class="class_hover"
            :class="status === null ? 'bom' : ''"
            @click="select(null)"
            style="padding:0 20px 0 20px"
          >全部</div>
          <div class="class_hover" :class="status === 0 ? 'bom' : ''" @click="select(0)">正在拼单</div>
          <div class="class_hover" :class="status === 1 ? 'bom' : ''" @click="select(1)">拼单成功</div>
          <div class="class_hover" :class="status === 2 ? 'bom' : ''" @click="select(2)">我要拼单</div>
          <div class="triang"></div>
          <div class="triang1"></div>
        </div>
      </div>

      <div class="box_list" v-if="isshow">
        <el-row :gutter="10">
          <el-col :span="6" v-for="item in da_list" :key="item.id">
            <router-link :to="'/group_details?id=' +  item.id">
              <div class="group_item">
                <div class="group_item_img">
                  <img :src="item.image" alt />
                </div>
                <div class="group_item_text">
                  <div class="group_item_title">{{item.title}}</div>
                  <div>货号 : {{item.item_no}}</div>
                  <div>品牌 : {{item.brand}}</div>
                  <div>规格 : {{item.specification}}</div>
                </div>
                <div
                  class="group_ing"
                  :class="item.status === '1' ? 'success_group' : 'success_ing'"
                >{{item.status === '1' ? '拼单成功' : '正在拼单'}}</div>
              </div>
            </router-link>
          </el-col>
          <el-col v-if="da_list.length === 0">
            <div align="center">
              <img src="https://www.bioflin.com:83/image/none/noGroup.jpg" alt />
            </div>
          </el-col>
        </el-row>
        <el-pagination
          v-if="da_list.length > 0"
          style="text-align:center;margin-top:30px"
          hide-on-single-page
          :page-size="16"
          prev-text="上一页"
          next-text="下一页"
          @current-change="setpage"
          background
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
      <div class="from1" v-else>
        <el-form
          :model="form"
          label-width="80px"
          style="width:460px;margin:0 auto;padding:60px 0 80px 0"
        >
          <el-form-item label="商品货号:">
            <el-input v-model="form.item" placeholder="请输入商品货号" @blur="change_item"></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="商品规格:">
            <el-input v-model="form.cation"></el-input>
          </el-form-item>
          <el-form-item label="商品品牌:">
            <el-input v-model="form.brand"></el-input>
          </el-form-item>
          <el-form-item label="商品价格:">
            <el-input v-model="form.price"></el-input>
          </el-form-item>
          <el-form-item label="总数量:">
            <el-input v-model="form.number"></el-input>
          </el-form-item>
          <el-form-item label="购买数量:">
            <el-input v-model="form.p_number" placeholder="请输入购买数量"></el-input>
          </el-form-item>
          <el-form-item label="拼购规格:">
            <el-input v-model="form.p_price" placeholder="请输入拼购规格"></el-input>
          </el-form-item>
          <el-form-item label="发起人:">
            <el-input v-model="form.p_name" placeholder="发起人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input v-model="form.mobile" placeholder="联系电话"></el-input>
          </el-form-item>
          <el-form-item style="text-align:center">
            <el-button size="medium" type="primary" style="width:130px" @click="submit">上传</el-button>
            <el-button
              size="medium"
              type="info"
              style="width:130px;margin-left:50px"
              @click="clear_submit"
            >取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div style="height:60px"></div>

    <el-dialog title="提示" :visible.sync="centerDialogVisible1" width="490px" center>
      <div style="text-align:center;padding:20px 0">抱歉！商城暂无此商品，请重新输入</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width:120px" @click="centerDialogVisible1 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible1: false,
      dialogVisible: false,
      dialogVisible_text: "",
      isshow: true,
      serve: this.$store.state.serve,
      list: [],
      unfol: true,
      form: {
        item: null,
        name: null,
        cation: null,
        brand: null,
        price: null,
        number: null,
        p_number: null,
        p_price: null,
        p_name: null,
        mobile: null,
        id: null
      },
      da_list: [],
      status: null,
      total: null,
      page: null
    };
  },
  created() {
    this.get_groupList();
    this.da_grouplist();
  },

  activated() {
    this.$store.commit("set_top_nav", "3");
    this.status = null;
  },
  methods: {
    clear_submit() {
      this.form.item = null;
      this.form.name = null;
      this.form.cation = null;
      this.form.brand = null;
      this.form.price = null;
      this.form.number = null;
      this.form.p_number = null;
      this.form.p_price = null;
      this.form.p_name = null;
      this.form.mobile = null;
    },
    submit() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const formData = new FormData();
      formData.append("mobile", this.$cookies.get("user"));
      formData.append("token", this.$cookies.get("token"));
      if (this.form.item != null) {
        formData.append("item_no", this.form.item);
      }
      if (this.form.name != null) {
        formData.append("title", this.form.name);
      }
      if (this.form.cation != null) {
        formData.append("specification", this.form.cation);
      }
      if (this.form.brand != null) {
        formData.append("brand", this.form.brand);
      }
      if (this.form.price != null) {
        formData.append("selling_price", this.form.price);
      }
      if (this.form.p_name != null) {
        formData.append("publish_member", this.form.p_name);
      }
      if (this.form.mobile != null) {
        formData.append("link_phone", this.form.mobile);
      }
      if (this.form.id != null) {
        formData.append("p_id", this.form.id);
      }
      if (this.form.number != null) {
        formData.append("number", this.form.number);
      }
      if (this.form.p_price != null) {
        formData.append("unit", this.form.p_price);
      }
      if (this.form.p_number != null) {
        formData.append("buy_number", this.form.p_number);
      }
      this.axios
        .post(this.serve + "/group/PublishGroup", formData, config)
        .then(res => {
          if (res.data.status === "success") {
            this.select(0);
            this.$message({
              type: "success",
              message: "上传成功",
              offset: "200"
            });
          } else if (res.data.status === "error") {
            this.dialogVisible = true;
            this.dialogVisible_text = res.data.msg;
          }
        });
    },
    change_item() {
      if (this.form.item !== null) {
        this.axios
          .get(this.serve + "/group/SearchItemNo", {
            params: {
              item_no: this.form.item
            }
          })
          .then(res => {
            if (res.data.status === "success") {
              this.form.name = res.data.data.title;
              this.form.cation = res.data.data.specification;
              this.form.brand = res.data.data.brand;
              this.form.price = res.data.data.selling_price;
              this.form.id = res.data.data.id;
            } else if (res.data.status === "error") {
              this.centerDialogVisible1 = true;
              this.form.name = null;
              this.form.cation = null;
              this.form.brand = null;
              this.form.price = null;
            }
          });

        this.axios
          .get(this.serve + "/group/MemberInfo", {
            params: {
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token")
            }
          })
          .then(res => {
            this.form.p_name = res.data.data.nickname;
            this.form.mobile = res.data.data.bind_mobile;
          });
      }
    },
    setpage(page) {
      this.page = page;
      this.da_grouplist();
    },
    select(status) {
      this.page = null;
      this.status = status;
      if (status === 2) {
        this.axios
          .get(this.serve + "/isLogin", {
            params: {
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token")
            }
          })
          .then(res => {
            if (res.data.data == 1) {
              this.isshow = false;
            } else {
              this.$router.push("/login");
            }
          });
      } else {
        this.isshow = true;
      }
      this.da_grouplist();
    },
    da_grouplist(status) {
      this.axios
        .get(this.serve + "/group/GroupList", {
          params: {
            status: this.status,
            page: this.page
          }
        })
        .then(res => {
          if (res.data.status === "success") {
            this.da_list = res.data.data.results;
            this.page = res.data.data.page;
            this.total = res.data.data.total;
          } else if (res.data.status === "error") {
            this.da_list = [];
          }
        });
    },
    change_group(id) {
      this.$router.push("/viewGroup?id=" + id);
    },
    get_groupList() {
      this.axios.get(this.serve + "/groupBuy").then(res => {
        if (res.data.status === "success") {
          const json = res.data.data.results.concat();
          if (this.unfol) {
            this.list = json.slice(0, 8);
          } else {
            this.list = json;
          }
        }
      });
    },
    change_unfol() {
      if (this.unfol) {
        this.unfol = false;
        this.get_groupList();
      } else {
        this.unfol = true;
        this.get_groupList();
      }
    }
  }
};
</script>

<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.el-dialog__footer {
  text-align: center;
}
.group_index {
  width: 100%;
  border-top: 2px solid #e2211c;
  .group_top {
    width: 100%;
    background-image: url("https://www.bioflin.com:83/image/group/top.jpg");
    background-size: 100% 100%;
    height: 266px;
  }
  .group_list {
    width: 1190px;
    background: rgba(255, 255, 255, 1);
    margin: -133px auto 0 auto;
    padding: 40px 60px;
    box-sizing: border-box;
    .group_item {
      width: 260px;
      height: 290px;
      margin-bottom: 20px;
      position: relative;
      .group_item_img {
        margin: 0 auto;
        width: 220px;
        height: 220px;
        position: relative;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .group_item_img:hover img {
        animation-name: move;
        animation-duration: 0.3s;
        animation-fill-mode: both;
      }
      @keyframes move {
        0% {
          position: absolute;
          left: 0;
          top: 0;
        }
        100% {
          position: absolute;
          left: 0;
          top: -5px;
        }
      }

      .group_item_title {
        height: 14px;
        font-size: 14px;
        font-family: " Microsoft YaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-top: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
      .group_item_title:hover {
        color: #e2211c;
      }
      .group_item_money {
        display: flex;
        justify-content: space-between;
        padding-right: 20px;
        box-sizing: border-box;
        align-items: center;
        margin-top: 14px;
        .group_item_money1 {
          font-size: 22px;
          font-weight: 400;
          color: rgba(226, 33, 28, 1);
        }
        .group_item_money2 {
          font-size: 16px;
          font-weight: 400;
          text-decoration: line-through;
          color: rgba(153, 153, 153, 1);
        }
      }
    }
  }
  .unfol {
    width: 1190px;
    margin: 0 auto;
    text-align: center;
    padding: 18px 0 8px 0;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    cursor: pointer;
    font-weight: 400;
    color: rgba(226, 33, 28, 1);
  }
  .group_box_box {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .group_box {
    background-image: url("https://www.bioflin.com:83/image/group/bottom.jpg");
    background-size: 100% 100%;
    height: 333px;
    .pack {
      font-size: 28px;
      letter-spacing: 16px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      position: absolute;
      left: 50%;
      margin-left: -84px;
      top: 58px;
    }
    .classify {
      width: 910px;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      position: relative;
      position: absolute;
      top: 160px;
      left: 50%;
      margin-left: -455px;
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      display: flex;
      justify-content: space-around;
      line-height: 50px;
      div {
        cursor: pointer;
      }
      .class_hover:hover {
        border-bottom: 6px solid #e2211c;
        color: #e2211c;
      }
      .bom {
        border-bottom: 6px solid #e2211c;
        color: #e2211c;
      }

      .triang {
        width: 0;
        height: 0;
        border-top: 25px solid transparent;
        border-bottom: 25px solid transparent;
        border-right: 25px solid #fff;
        position: absolute;
        top: 0;
        left: -25px;
      }
      .triang1 {
        width: 0;
        height: 0;
        border-top: 25px solid transparent;
        border-bottom: 25px solid transparent;
        border-left: 25px solid #fff;
        position: absolute;
        top: 0;
        right: -25px;
      }
    }
  }
  .box_list {
    width: 1200px;
    margin: -110px auto 0 auto;
    .group_item {
      width: 290px;
      height: 325px;
      background: rgba(255, 255, 255, 1);
      margin-bottom: 10px;
      position: relative;

      .group_item_img {
        width: 200px;
        height: 200px;
        margin: 0 auto;
        padding-top: 20px;
        padding-bottom: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .group_item_title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .group_item_text {
        padding: 0 20px;
        line-height: 22px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
      .group_ing {
        width: 100px;
        height: 38px;
        border-radius: 19px 0px 0px 19px;
        font-size: 16px;
        font-weight: 400;

        position: absolute;
        bottom: 10px;
        right: 0px;
        text-align: center;
        line-height: 38px;
      }
      .success_group {
        background: rgba(255, 228, 208, 1);
        color: rgba(226, 33, 28, 1);
      }
      .success_ing {
        color: rgba(255, 255, 255, 1);
        background: rgba(242, 67, 51, 1);
      }
    }
  }
  .from1 {
    min-height: 800px;
    width: 960px;
    background-color: #fff;
    margin: 0 auto;
    margin-top: -110px;
  }
}
</style>